import jQuery from "jquery";
const $ = jQuery; // ドルマークに参照を代入(慣習的な $ を使うため)

import Swiper from 'swiper/bundle'; // import Swiper JS ALL

/*
 * Common
*/

var j$ = jQuery,
    $nav = j$(".switching"),
    $slideLine = j$(".slide"),
    $currentItem = j$(".current");

j$(function(){
  // Menu has active item
  if ($currentItem[0]) {
    $slideLine.css({
      "width": $currentItem.width(),
      "left": $currentItem.position().left
    });
  }

  // Underline transition
  j$($nav).find("li").hover(
    // Hover on
    function(){
      $slideLine.css({
        "width": j$(this).width(),
        "left": j$(this).position().left
      });
    },
    // Hover out
    function(){
      if ($currentItem[0]) {
        // Go back to current
        $slideLine.css({
          "width": $currentItem.width(),
          "left": $currentItem.position().left
        });
      } else {
        // Disapear
        $slideLine.width(0);
      }
    }
   );
});












/*
var beforePos = 0;//スクロールの値の比較用の設定

//スクロール途中でヘッダーが消え、上にスクロールすると復活する設定を関数にまとめる
function ScrollAnime() {
//  var elemTop = $('#area-2').offset().top;//#area-2の位置まできたら
  var elemTop = $('article').offset().top;//#area-2の位置まできたら
  var scroll = $(window).scrollTop();
  //ヘッダーの出し入れをする
  if(scroll == beforePos) {
    //IE11対策で処理を入れない
  }else if(elemTop > scroll || 0 > scroll - beforePos){
    //ヘッダーが上から出現する
    $('#header').removeClass('UpMove');	//#headerにUpMoveというクラス名を除き
    $('#header').addClass('DownMove');//#headerにDownMoveのクラス名を追加
  }else {
    //ヘッダーが上に消える
    $('#header').removeClass('DownMove');//#headerにDownMoveというクラス名を除き
    $('#header').addClass('UpMove');//#headerにUpMoveのクラス名を追加
  }
  if(scroll == 0) {
    $('#header').removeClass('DownMove');//#headerにDownMoveというクラス名を除き
    $('#header').removeClass('UpMove');//#headerにUpMoveのクラス名を追加
  }

  beforePos = scroll;//現在のスクロール値を比較用のbeforePosに格納
}


// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function () {
	ScrollAnime();//スクロール途中でヘッダーが消え、上にスクロールすると復活する関数を呼ぶ
});

// ページが読み込まれたらすぐに動かしたい場合の記述
$(window).on('load', function () {
	ScrollAnime();//スクロール途中でヘッダーが消え、上にスクロールすると復活する関数を呼ぶ
});
*/


/*
 * Toggle switch

const checkbox = document.getElementById('check-cyanman')

checkbox.addEventListener('change', (event) => {
  if (event.currentTarget.checked) {
    location.href = 'https://cyanman.jp/';
  } else {
    location.href = 'https://cyanmagazine.jp/';
  }
});
*/

/*
 * Modal - MAGAZINE NEW ISSUE
 */

$('.modal-button').click(function(){
  var buttonId = $(this).attr('id');
  $('#modal-container').removeAttr('class').addClass(buttonId);
  $('body').addClass('modal-active');
})

$('#modal-container').click(function(){
  $(this).addClass('out');
  $('body').removeClass('modal-active');
});



// Single
/*
const postSwiper = new Swiper('.post-swiper', {
  slidesPerView: 1,
  spaceBetween: 18,
  centeredSlides: false,
  breakpoints: {
    768: {
      slidesPerView: 3,
      spaceBetween: 48,
      initialSlide: 1,
      centeredSlides: true,
    }
  }
});
*/

// Hero
const heroSwiper = new Swiper('.hero-swiper', {
  loop: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  // speed: 1000, // 少しゆっくり(デフォルトは300)
  autoplay: { // 自動再生
    delay: 4000, // 1.5秒後に次のスライド
  },
});


// Single - Custom block - Swiper
const singleCustomBlockSwiper = new Swiper('.single-customblock-swiper', {
/*
  loop: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
  },
  */
  scrollbar: {
    el: ".swiper-scrollbar",
//    hide: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  spaceBetween: 24,
  centeredSlides: false,
  autoHeight: true,
  slidesPerView: 1,

  breakpoints: {
    768: {
      slidesPerView: 2,
    }
  }

});


/*
 * Single product
 */
 /*
$(function() {
  //swiper 768以下で起動
  var swiper;
  $(window).on('load resize', function(){
    var w = $(window).width();
    if (w <= 767.98) {
      if (swiper) {
        return;
      } else {
        swiper = new Swiper('#single-product-gallery', {
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
        });
      }
    } else {
      if (swiper) {
        swiper.destroy();
        swiper = undefined;
      }
    }
  });
});

const SingleProductSubgallerySwiper = new Swiper('#single-product-subgallery', {
  slidesPerView: "auto",
  spaceBetween: 18,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    991: {
      slidesPerView: "auto",
      spaceBetween: 48,
    }
  }
});
*/
